import React, { FC, ReactElement, } from "react";
import { classNames, parseClasses, TextInput, } from ".";

interface Props {
    value?: string | number;
    name?: string;
    className?: string | string[];
    disabled?: boolean;
    readonly?: boolean;
    focused?: boolean;
    placeholder?: string;
    hideDefaultOption?: boolean;

    onChange: (e: React.ChangeEvent<HTMLSelectElement>) => void;

    children?: React.ReactNode;
}

const DEFAULT_VALUE = "";
const PLACEHOLDER_TEXT = "Choose...";

export const Select: FC<Props> = (props): ReactElement => {
    const { value, name, className, disabled, readonly, placeholder, onChange, focused, hideDefaultOption, } = props;

    const containerCss = classNames([
        "__select__",
    ]);

    const selectCss = classNames([
        "form-select",
        parseClasses(className),
        readonly ? "readonly" : null,
    ]);

    const defaultOption = <option value="">{placeholder || PLACEHOLDER_TEXT}</option>;

    if (readonly) {
        return (
            <div className={containerCss}>
                {renderReadonly(props)}
            </div>
        )
    }

    const parsedValue = (value !== null && value !== undefined) ? value : DEFAULT_VALUE;

    return (
        <div className={containerCss}>
            <select
                name={name}
                className={selectCss}
                value={parsedValue}
                disabled={disabled}
                onChange={onChange}
                autoFocus={focused}
            >
                {!hideDefaultOption && defaultOption}
                {props.children}
            </select>
        </div>
    );
}

const renderReadonly = (props: Props): ReactElement => {
    const { value, name, className, } = props;

    return (
        <TextInput
            value={value || ""}
            name={name}
            className={className}
            readonly={true}
        />
    );
}
